import React, { useState } from 'react';
import { ApolloError, useMutation } from '@apollo/client';
import { GraphQLError } from 'graphql';

// import FacebookLogin from 'components/buttons/FacebookLogin';
import SignFormsContainer from 'components/forms/styled/SignFormsContainer';
import { afterSignRedirect } from 'utils/navigation';
import { SignInFormFields } from 'components/forms/SignInForm/types';
import { withTranslation } from 'lib/i18n';
import { SignInMutation, SignInMutationVariables } from 'types/graphql';

import Form from './composeForm';
import SING_IN_MUTATION from './mutations/signIn';
import { FORM_ID } from './constants';
import { SignInFormProps, SignInFormState } from './types';

const SignInForm: React.FC<SignInFormProps> = props => {
  const [state, setState] = useState<SignInFormState>({});
  const [mutate] = useMutation<SignInMutation, SignInMutationVariables>(
    SING_IN_MUTATION,
    {
      fetchPolicy: 'no-cache',
    },
  );

  const handleCompleted = (): void => {
    afterSignRedirect();
  };

  const handleError = (
    error: Readonly<GraphQLError[]>,
  ): Readonly<GraphQLError[]> => {
    if (error.length) {
      setState({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        errorMessage: props.t(`signInForm.responseError.${error[0].type}`),
      });
    }

    return error;
  };

  const handleErrorReset = (): void => {
    if (state.errorMessage) setState({ errorMessage: undefined });
  };

  const handleSignIn = (_variables: unknown): void => {
    const variables = _variables as SignInFormFields;
    mutate({ variables })
      .then(() => {
        handleCompleted();
      })
      .catch((error: ApolloError) => {
        handleError(error.graphQLErrors);
      });
  };
  // <FacebookLogin label={props.t('facebookLogin.signIn')} />
  return (
    <SignFormsContainer>
      <Form
        id={FORM_ID}
        errorMessage={state.errorMessage}
        i18n={props.i18n}
        t={props.t}
        onChange={handleErrorReset}
        onSubmit={handleSignIn}
      />
    </SignFormsContainer>
  );
};

export default withTranslation('forms')(SignInForm);
